import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/FromTreeToViewer/Model.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/esnext.string.at.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { sample, combine, createStore, guard, merge, createEvent } from 'effector';
import * as api from '@gmini/sm-api-sdk';
import { isNotEmpty } from '@gmini/utils';
import { findElementFromViewer } from "../../forge-viewer/service/findElemetFromViewer";
import { selectedModels } from "../ModelSelect/selectedModels";
import * as viewerSelect from "../../forge-viewer/model/selectModel";
var getAllReferences = api.GetAllReferences.fetch.createContext({
  name: 'getAllReferences'
});
export function createViewerDisplayModel(_ref) {
  var nodes$ = _ref.nodes$,
      currentEntity$ = _ref.currentEntity$,
      searchModel = _ref.searchModel,
      getViewerId = _ref.getViewerId,
      getClsModels = _ref.getClsModels;
  var createModelMapEvent = createEvent({
    name: "createModelMapEvent",
    sid: "7f2ep7"
  });
  var resetChecked = createEvent({
    name: "resetChecked",
    sid: "-9s5aml"
  });
  var checkedData$ = createStore(null, {
    name: "checkedData$",
    sid: "-td8qyx"
  }).on(createModelMapEvent, function (_state, nextState) {
    return nextState;
  }).reset(resetChecked);
  sample({
    ɔ: [{
      source: nodes$,
      clock: checked$,
      fn: function fn(nodes, checkedStore) {
        return {
          nodes: nodes,
          checkedStore: checkedStore
        };
      }
    }],
    config: {
      sid: "13532f"
    }
  }).watch(function (params) {
    var _params$checkedStore;

    if (!((_params$checkedStore = params.checkedStore) !== null && _params$checkedStore !== void 0 && _params$checkedStore.checkedMap)) {
      resetChecked();
      return;
    }

    var createModelsMapWorker = new Worker(new URL('./createModelsMap.worker.js', import.meta.url));
    createModelsMapWorker.postMessage(params);

    createModelsMapWorker.onerror = function (e) {
      console.error(e);
      createModelsMapWorker.terminate();
    };

    createModelsMapWorker.onmessage = function (e) {
      try {
        createModelMapEvent(JSON.parse(e.data));
      } catch (e) {
        console.error(e);
      }

      createModelsMapWorker.terminate();
    };
  });
  guard({
    ɔ: [{
      source: sample({
        ɔ: [{
          source: combine({
            ɔ: [{
              checkedData: checkedData$,
              checkedStore: checked$,
              viewerShowMode: viewerSelect.showInViewerMode$,
              pending: getAllReferences.pending$,
              currentUserClassifier: currentEntity$
            }],
            config: {
              name: "source",
              sid: "eekuvs"
            }
          }),
          clock: merge([checked$.updates, viewerSelect.showInViewerMode$.updates, currentEntity$.updates], {
            name: "clock",
            sid: "h4kxaj"
          }),
          fn: function fn(_ref2) {
            var checkedData = _ref2.checkedData,
                checkedStore = _ref2.checkedStore,
                viewerShowMode = _ref2.viewerShowMode,
                pending = _ref2.pending,
                currentUserClassifier = _ref2.currentUserClassifier;

            if (pending || !currentUserClassifier) {
              return null;
            }

            if (checkedData && checkedStore && viewerShowMode !== 'ShowAll') {
              var request = Object.keys(checkedData).reduce(function (acc, key) {
                var group = checkedData[key];

                if (!group || Array.isArray(group) || !checkedStore.checkedMap[key]) {
                  return acc;
                }

                return {
                  groups: [].concat(_toConsumableArray(acc.groups), [{
                    groupId: group.id,
                    classifierId: group.parentClassifierId,
                    classifierVersion: checkedStore.path === 'Own' ? currentUserClassifier.version : group.parentClassifierVersion
                  }])
                };
              }, {});
              return Object.keys(request).length ? request : null;
            }

            return null;
          }
        }],
        config: {
          name: "source",
          sid: "dxj8fv"
        }
      }),
      filter: Boolean,
      target: getAllReferences.submit
    }],
    config: {
      sid: "2jdjfq"
    }
  });
  var viewerRefsFromGroups = sample({
    ɔ: [{
      source: checkedData$,
      clock: getAllReferences.doneData,
      fn: function fn(viewerMap, data) {
        if (viewerMap) {
          return Object.keys(viewerMap).reduce(function (acc, key) {
            var group = viewerMap[key];

            if (!group || Array.isArray(group)) {
              return acc;
            }

            var ref = data.groups.find(function (groupData) {
              return groupData.groupId === group.id;
            });

            if (ref) {
              var bimModels = getClsModels(ref.classifierId, ref.classifierVersion);
              var model = bimModels.at(0);
              return model ? _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, _toConsumableArray(ref.viewerRefs.map(function (ref) {
                return _objectSpread(_objectSpread({}, ref), {}, {
                  viewerId: getViewerId(model, ref)
                });
              })))) : acc;
            }

            return acc;
          }, {});
        }

        return null;
      }
    }],
    config: {
      name: "viewerRefsFromGroups",
      sid: "po1ykx"
    }
  });
  checkedData$.on(viewerRefsFromGroups, function (viewerRefsFromChecked, viewerRefsFromGroups) {
    if (viewerRefsFromChecked && viewerRefsFromGroups) {
      var data = _objectSpread({}, viewerRefsFromChecked);

      Object.keys(viewerRefsFromGroups).map(function (key) {
        if (data[key]) {
          data[key] = _objectSpread({}, viewerRefsFromGroups[key]);
        }
      });
      return data;
    }
  });
  checkedData$.watch(function (checkedData) {
    if (checkedData) {
      viewerSelect.selectMultiply(getViewerDataFromChecked(checkedData));
      return;
    }

    viewerSelect.selectMultiply(null);
  });
  sample({
    ɔ: [{
      source: viewerSelect.showInViewerMode$,
      clock: searchModel.resetSearchNodes,
      fn: function fn(showInViewerMode) {
        if (showInViewerMode !== 'ShowAll') {
          viewerSelect.resetShowMode();
          viewerSelect.changeViewerMode(showInViewerMode);
        }
      }
    }],
    config: {
      sid: "-qbajav"
    }
  });

  //TODO Viewer отрефакторить и разделить на разные модели вздаимодействие вьювера с чекбоксами и selectedModels
  function getViewerDataFromChecked(viewerRefsFromChecked) {
    // TODO код ниже можно разрулить  new Map, тем самым убрать find и filter(при больших объемах данных скорость работы аглоритма ниже будет стремительно падать)
    return Object.values(viewerRefsFromChecked).map(function (value) {
      return !Array.isArray(value) ? null : value;
    }).filter(isNotEmpty).flatMap(function (node) {
      return node.flat();
    }).reduce(function (acc, viewerRef) {
      var duplicate = acc.find(function (item) {
        return item.viewerId === viewerRef.viewerId;
      });

      if (!duplicate) {
        return [].concat(_toConsumableArray(acc), [{
          viewerId: viewerRef.viewerId,
          externalIds: [viewerRef.externalId]
        }]);
      }

      var currData = duplicate.externalIds.filter(function (externalId) {
        return externalId === viewerRef.externalId;
      });

      if (!currData.length) {
        duplicate.externalIds.push(viewerRef.externalId);
        return acc;
      }

      return acc;
    }, []);
  }
}
export var updateChecked = createEvent({}, {
  name: "updateChecked",
  sid: "laww1"
});
export var resetChecked = createEvent({}, {
  name: "resetChecked",
  sid: "bk4s4k"
});
var checked$ = createStore(null, {
  name: "checked$",
  sid: "f6aeu5"
}).on(updateChecked, function (_, checkedModel) {
  if (!Object.keys(checkedModel.checkedMap).length) {
    viewerSelect.resetShowMode();
  }

  return checkedModel;
}).on(resetChecked, function (state, path) {
  if (path === 'Own' && (state === null || state === void 0 ? void 0 : state.path) === 'Own' || path === 'Source' && (state === null || state === void 0 ? void 0 : state.path) === 'Source') {
    return null;
  }

  return state;
}).reset(viewerSelect.resetMultiplySelect);
export var checkedAndNotLoaded$ = combine({
  ɔ: [selectedModels.models$, viewerSelect.multiplyViewerSelect$, function (selectedModels, multiplyViewerSelect) {
    if (!(multiplyViewerSelect !== null && multiplyViewerSelect !== void 0 && multiplyViewerSelect.length)) {
      return false;
    }

    if (!selectedModels) {
      return true;
    }

    var checkedUrns = multiplyViewerSelect.map(function (modelInfo) {
      return modelInfo.viewerId;
    });
    var loadedUrns = selectedModels && selectedModels.map(function (modelInfo) {
      return modelInfo.viewerId;
    });
    return !!(loadedUrns && checkedUrns.some(function (urn) {
      return !loadedUrns.includes(urn);
    }));
  }],
  config: {
    name: "checkedAndNotLoaded$",
    sid: "-bl0m4b"
  }
});
sample({
  ɔ: [{
    source: selectedModels.models$,
    clock: findElementFromViewer,
    fn: function fn(selectedModels, findElementFromViewer) {
      var treeModel = selectedModels === null || selectedModels === void 0 ? void 0 : selectedModels.find(function (model) {
        return Object.keys(findElementFromViewer).some(function (viewerId) {
          return model.viewerId === viewerId;
        });
      });

      if (!treeModel) {
        return null;
      }

      var modelId = treeModel.modelId,
          modelVersion = treeModel.modelVersion;
      return {
        //Пока в findElementFromViewer можно выбрать только один элемент
        externalId: Object.values(findElementFromViewer)[0][0],
        modelId: modelId,
        modelVersion: modelVersion
      };
    }
  }],
  config: {
    sid: "-c1qp5b"
  }
}).watch(function (request) {
  if (request) {
    api.UserClassifier.getElementFromViewer.defaultContext.submit(request);
  }
});